export const types = {
    // Sync
    FILL_PROFILE:  'FILL_PROFILE',
    UPDATE_AVATAR: 'UPDATE_AVATAR',
    CLEAR_PROFILE: 'CLEAR_PROFILE',

    // Async
    UPDATE_NAME_ASYNC:     'UPDATE_NAME_ASYNC',
    UPDATE_AVATAR_ASYNC:   'UPDATE_AVATAR_ASYNC',
    UPDATE_PASSWORD_ASYNC: 'UPDATE_PASSWORD_ASYNC',
};
